import { useCallback } from 'react';
import { fromPairs, toPairs } from 'ramda';
import { deferUntilNewTitle } from '../../lib/deferUntilNewTitle';
import { tc } from '../../lib/trackingContext';
import { useCartItems } from '../useCart';
import { getCookies } from '../useCookies';

export const useOrderConvertedTracking = () => {
  const { cartItems } = useCartItems();

  const trackOrderConverted = useCallback(
    result => {
      const sessionParams = JSON.parse(getCookies()?.sessionQueryParams ?? '{}');

      // This is to coerce the keys to lowercase, because query params are case insensitive.
      const referralParameters = fromPairs(
        toPairs(sessionParams).map(entry => [entry[0].toLowerCase(), entry[1]])
      );
      deferUntilNewTitle(() => {
        tc.track('Order Converted', {
          addToScopeOnce: {
            order: result.checkout.data[0],
            products: cartItems,
            referralParameters
          }
        });
      });
    },
    [cartItems]
  );

  return { trackOrderConverted };
};
